/**
 * 로고디자인 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: 'adLogoDesign',
  title: '로고디자인 신청',
  
  api: {
    list: {
      method: 'GET',
      url: '/advertisement/logo-design/admin/logo-designs'
    },
    count: {
      method: 'GET',
      url: '/advertisement/logo-design/admin/logo-designs/count'
    },
    submitted: {
      method: 'POST',
      url: '/advertisement/logo-design/admin/logo-designs/submitted'
    },
    paid: {
      method: 'POST',
      url: '/advertisement/logo-design/admin/logo-designs/paid'
    },
    complete: {
      method: 'POST',
      url: '/advertisement/logo-design/admin/logo-designs/complete'
    },
    refund: {
      method: 'POST',
      url: '/advertisement/admin/campaigns/refund',
      version: 2,
    },
    delete: {
      method: 'DELETE',
      url: '/advertisement/logo-design/admin/logo-designs'
    }
  },

  filters: {
    default: {
      status: '전체',
      submitDate: '',
      keyword: '',
      page: 1,
      limit: 50,
      submitted: '전체',
      paid: '전체'
    },
    schema: [
      {
        name: 'keyword',
        label: '검색',
        type: 'text',
        placeholder: '신청자, 브랜드명'
      },
      {
        name: 'submitDate',
        label: '접수일',
        type: 'date'
      },
      {
        name: 'submitted',
        label: '접수여부',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'complete', label: '접수완료' },
          { value: 'notComplete', label: '미접수' }
        ]
      },
      {
        name: 'paid',
        label: '결제상태',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'complete', label: '결제완료' },
          { value: 'notComplete', label: '미결제' },
          { value: 'refund', label: '환불' }
        ]
      },
      {
        name: 'status',
        label: '상태',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'waiting', label: '대기중' },
          { value: 'processing', label: '진행중' },
          { value: 'completed', label: '종료' }
        ]
      }
    ]
  },

  summary: {
    fields: [
      { key: 'totalCount', label: '총 신청' },
      { key: 'waitingCount', label: '대기중' },
      { key: 'processingCount', label: '진행중' },
      { key: 'completedCount', label: '종료' }
    ]
  },

  table: {
    keyField: 'adLogoDesignId',
    columns: [
      {
        key: 'adCampaignMetaId',
        label: '아이디',
        center: true
      },
      {
        key: 'createdAt',
        label: '캐랭접수시간',
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: 'userName',
        label: '신청자(ID)\n상태',
        center: true,
        render: (row) => (
          <>
            <div>{row.userName}{row.userId ? ` (${row.userId})` : ''}</div>
            <div>
              <span className={`badge badge-${row.status}`}>
                {getStatusLabel(row.status)}
              </span>
            </div>
          </>
        )
      },
      {
        key: 'submitDate',
        label: '접수일',
        center: true,
        render: (row) => row.submitDate ? row.submitDate.split('T')[0] : ''
      },
      {
        key: 'title',
        label: '상품명\n디자인타입',
        center: true,
        render: (row) => (
          <>
            <div>{row.title}</div>
            <div>{row.designTypeTitle}</div>
          </>
        )
      },
      {
        key: 'brandName',
        label: '브랜드명\n연락처\n플레이스 URL',
        center: true,
        render: (row) => (
          <>
            <div>{row.brandName}</div>
            <div>{row.phoneNum || ''}</div>
            <div>
              {row.placeUrl && (
                <a href={row.placeUrl} target="_blank" rel="noopener noreferrer">
                  {row.placeUrl}
                </a>
              )}
            </div>
          </>
        )
      },
      {
        key: 'totalAmount',
        label: '총금액',
        center: true,
        render: (row) => row.totalAmount ? `${row.totalAmount.toLocaleString()}원` : ''
      },
      {
        key: 'paymentType',
        label: '결제방법\n결제상태',
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === 'card' ? '카드' :
               row.paymentType === 'v_bank' ? '가상계좌' :
               row.paymentType === 'point' ? '포인트 결제' : '계좌이체'}
            </div>
            <div>
              {row.isPaid === 2 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? '결제완료' : '미결제'}`}>
                  {row.isPaid === 1 ? '결제완료' : '미결제'}
                </span>
              )}
            </div>
          </>
        )
      },
      {
        key: 'notification',
        label: '알림톡',
        center: true,
        render: (row) => {
          const productName = row.title || '로고 디자인';
          
          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ''}
              data-purchase-amount={row.totalAmount ?? ''}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: 'memo',
        label: '메모',
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? 'memo-btn has-memo' : 'memo-btn'}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ''}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : '메모'}
          </button>
        ),
      }
    ]
  },

  actions: [
    {
      id: 'submitted',
      label: '접수/취소',
      actionType: 'submitted',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasUnsubmitted = items.some(item => 
          selectedIds.includes(item.adLogoDesignId) && item.isSubmitted !== 1
        );
        return {
          adLogoDesignIds: selectedIds,
          toggleValue: hasUnsubmitted ? 1 : 0
        };
      }
    },
    {
      id: 'complete',
      label: '완료(종료)',
      actionType: 'complete',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: (selectedIds, items) => {
        const hasUncompleted = items.some(item => 
          selectedIds.includes(item.adLogoDesignId) && item.isCompleted !== 1
        );
        return hasUncompleted ? '선택한 신청을 완료 처리하시겠습니까?' : '선택한 신청을 취소 처리하시겠습니까?';
      },
      payloadBuilder: (selectedIds, items) => {
        const hasUncompleted = items.some(item => 
          selectedIds.includes(item.adLogoDesignId) && item.isCompleted !== 1
        );
        return {
          adLogoDesignIds: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0
        };
      }
    },
    {
      id: 'paid',
      label: '결제완료',
      actionType: 'paid',
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(item => 
          selectedIds.includes(item.adLogoDesignId) && item.isPaid === 1
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds) => ({
        adLogoDesignIds: selectedIds,
        toggleValue: 1
      })
    },
    {
      id: 'refund',
      label: '환불',
      actionType: 'refund',
      requires: 'ad.campaign.refund', // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adLogoDesignId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: 'delete',
      label: '삭제',
      actionType: 'delete',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: '선택한 신청을 삭제하시겠습니까?',
      payloadBuilder: (selectedIds) => ({
        adLogoDesignIds: selectedIds
      })
    }
  ],

  download: {
    type: 'xlsx',
    fileName: '로고디자인_신청목록.xlsx',
    sheetName: '로고디자인신청목록',
    transformRow: (row) => ({
      신청자: row.userName || '',
      접수일: row.submitDate ? row.submitDate.split('T')[0] : '',
      디자인타입: row.designTypeTitle || '',
      상품명: row.title || '',
      브랜드명: row.brandName || '',
      연락처: row.phoneNum || '',
      플레이스URL: row.placeUrl || '',
      총금액: row.totalAmount || 0,
      결제방법: row.paymentType === 'card' ? '카드' :
                row.paymentType === 'v_bank' ? '가상계좌' :
                row.paymentType === 'point' ? '포인트 결제' : '계좌이체'
    })
  }
};

function getStatusLabel(status) {
  switch (status) {
    case 'waiting': return '대기중';
    case 'processing': return '진행중';
    case 'completed': return '종료';
    default: return status;
  }
}
